import ImagesUrl from "#constants/images.js";
import { AdminLayout } from "#layouts";
import { useSelector } from "react-redux";
import GrowersManagement from "../growersManagement";

const AgronomistDetail = () => {
  const agronomistDetailData = useSelector(
    (state) => state.agronomist?.agronomistDetails
  );

  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="detail_card_wrapper">
                <div className="agronomist_img">
                  <img
                    src={
                      agronomistDetailData?.image
                        ? agronomistDetailData?.image
                        : ImagesUrl.noProfile
                    }
                    alt="user"
                  />
                </div>
                <div className="agronomist_detail">
                  <div class="row gy-3 gx-4 gx-xxl-5">
                    <div class="col-md-6 col-lg-6">
                      <div class="common-statistics">
                        <div class="common-info-detail">
                          <h2 class="h4">Agronomist ID</h2>
                          <p class="mb-0">{agronomistDetailData?._id}</p>
                        </div>
                        <div class="common-info-detail">
                          <h2 class="h4">Phone Number</h2>
                          <p class="mb-0">
                            {`+ ${agronomistDetailData?.countryCode} ${agronomistDetailData?.phoneNumber}`}
                          </p>
                        </div>
                        <div class="common-info-detail">
                          <h2 class="h4">Email Address</h2>
                          <p class="mb-0">{agronomistDetailData?.email}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <div class="common-statistics">
                        <div class="common-info-detail">
                          <h2 class="h4">Full Name</h2>
                          <p class="mb-0">{`${agronomistDetailData?.firstName} ${agronomistDetailData?.lastName}`}</p>
                        </div>
                        <div class="common-info-detail">
                          <h2 class="h4">Location</h2>
                          <p class="mb-0">{agronomistDetailData?.location}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <GrowersManagement agronomistId={agronomistDetailData?._id} />
        </div>
      </section>
    </AdminLayout>
  );
};

export default AgronomistDetail;
